export function actionTypeCreator (module, type) {
  return `aliada/${module}/${type}`
}



// WEBPACK FOOTER //
// ./src/redux/modules/util.js